import z from 'zod';
import { numericString } from '../../../../../lib/schemas/numeric-string';
import { MAX_DISCOUNT, MIN_DISCOUNT } from './constants';

// Single definition of a valid discount (string in, number out), shared by the form validator and the
// preview parse below so they never disagree on the same input.
const discountField = numericString({ min: MIN_DISCOUNT, max: MAX_DISCOUNT });

/** The one-click form's shape: a single `discount` field, validated by TanStack Form via zod. */
export const discountFormSchema = z.object({ discount: discountField });

/** Lenient parse for the live preview: the entered discount, or null when empty/invalid. */
export function parsePreviewDiscount(raw: string): number | null {
  const result = discountField.safeParse(raw);
  return result.success ? result.data : null;
}
